'use es6';

import { DESIGN_COMPONENTS_CODE_ACCORDION_UPDATE } from 'DesignData/actions/ActionTypes';
/**
 *
 * @param {String|Number} id        The accordion id (not the item id).
 * @param {Object}        options
 */

export function updateAccordionOptions(id, options) {
  return {
    type: DESIGN_COMPONENTS_CODE_ACCORDION_UPDATE,
    id,
    data: {
      options
    }
  };
}